import type { InputKind } from "./outline-types";

export const SOURCE_FILE_TYPES = [
  { extension: ".txt", label: "TXT", mimeType: "text/plain", kind: "document" },
  { extension: ".md", label: "MD", mimeType: "text/markdown", kind: "document" },
  { extension: ".docx", label: "DOCX", mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", kind: "document" },
  { extension: ".pdf", label: "PDF", mimeType: "application/pdf", kind: "document" },
  { extension: ".pptx", label: "PPTX", mimeType: "application/vnd.openxmlformats-officedocument.presentationml.presentation", kind: "document" },
  { extension: ".csv", label: "CSV", mimeType: "text/csv", kind: "document" },
  { extension: ".xlsx", label: "XLSX", mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", kind: "document" },
  { extension: ".jpg", label: "JPG", mimeType: "image/jpeg", kind: "image" },
  { extension: ".jpeg", label: "JPEG", mimeType: "image/jpeg", kind: "image" },
  { extension: ".png", label: "PNG", mimeType: "image/png", kind: "image" },
  { extension: ".webp", label: "WebP", mimeType: "image/webp", kind: "image" },
] as const;

const PPTX_FILE_TYPE = SOURCE_FILE_TYPES.find((type) => type.extension === ".pptx")!;

export const SOURCE_FILE_ACCEPT = SOURCE_FILE_TYPES.flatMap((type) => [type.extension, type.mimeType]).join(",");
export const SOURCE_FILE_LABEL = SOURCE_FILE_TYPES.map((type) => type.label).join("、");

export function fileExtension(name: string): string {
  const match = /\.[^.]+$/.exec(name.toLowerCase());
  return match?.[0] || "";
}

export function sourceFileType(name: string) {
  const extension = fileExtension(name);
  return SOURCE_FILE_TYPES.find((type) => type.extension === extension);
}

export function isSupportedSourceFile(file: File): boolean {
  return Boolean(sourceFileType(file.name));
}

export function isSupportedImageFile(file: File): boolean {
  return sourceFileType(file.name)?.kind === "image";
}

export function fileTitle(name: string): string {
  return name.replace(/\.[^.]+$/, "");
}

export function fileModeLabel(sourceMode: InputKind): string {
  if (sourceMode === "pptx") return "PPTX";
  if (sourceMode === "file") return "资料文件";
  return "文字";
}

export function mimeTypeForFile(file: File, sourceMode: InputKind): string {
  if (file.type) return file.type;
  if (sourceMode === "pptx") return PPTX_FILE_TYPE.mimeType;
  return sourceFileType(file.name)?.mimeType || "application/octet-stream";
}
